import { useState } from 'react';
import type { RepairItem } from '@/types';

export function RepairCard({ repair, defaultExpanded = false }: { repair: RepairItem; defaultExpanded?: boolean }) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const totalCostIndependent = repair.costs?.independent?.find(c => c.name === 'total')?.average;
  const totalCostDealer = repair.costs?.dealer?.find(c => c.name === 'total')?.average;

  return (
    <div className="bg-obdai-deep rounded-xl overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full p-4 flex items-center justify-between text-left hover:bg-white/5 transition"
      >
        <div className="flex-1">
          <p className="text-white font-medium">{repair.title}</p>
          <div className="flex gap-4 mt-1">
            {totalCostIndependent && (
              <span className="text-green-400 text-sm">Ind: ${totalCostIndependent.toLocaleString()}</span>
            )}
            {totalCostDealer && (
              <span className="text-blue-400 text-sm">Dealer: ${totalCostDealer.toLocaleString()}</span>
            )}
          </div>
        </div>
        <svg
          className={`w-5 h-5 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {expanded && (
        <div className="p-4 pt-0 border-t border-white/10">
          {repair.description && (
            <p className="text-gray-400 text-sm mb-4">{repair.description}</p>
          )}

          {repair.costs && (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-gray-400 text-left">
                    <th className="pb-2"></th>
                    <th className="pb-2 text-center" colSpan={3}>Independent Shop</th>
                    <th className="pb-2 text-center" colSpan={3}>Dealer</th>
                  </tr>
                  <tr className="text-gray-500 text-xs">
                    <th className="pb-2">Type</th>
                    <th className="pb-2 text-right">Low</th>
                    <th className="pb-2 text-right">Avg</th>
                    <th className="pb-2 text-right">High</th>
                    <th className="pb-2 text-right">Low</th>
                    <th className="pb-2 text-right">Avg</th>
                    <th className="pb-2 text-right">High</th>
                  </tr>
                </thead>
                <tbody>
                  {['parts', 'labor', 'total'].map(costType => {
                    const indCost = repair.costs?.independent?.find(c => c.name === costType);
                    const dealerCost = repair.costs?.dealer?.find(c => c.name === costType);
                    if (!indCost && !dealerCost) return null;
                    return (
                      <tr key={costType} className={`border-t border-white/10 ${costType === 'total' ? 'font-medium' : ''}`}>
                        <td className="py-2 capitalize text-gray-300">{costType}</td>
                        <td className="py-2 text-right text-green-400">${indCost?.low || '-'}</td>
                        <td className="py-2 text-right text-green-400">${indCost?.average || '-'}</td>
                        <td className="py-2 text-right text-green-400">${indCost?.high || '-'}</td>
                        <td className="py-2 text-right text-blue-400">${dealerCost?.low || '-'}</td>
                        <td className="py-2 text-right text-blue-400">${dealerCost?.average || '-'}</td>
                        <td className="py-2 text-right text-blue-400">${dealerCost?.high || '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
